module.exports = __webpack_public_path__ + "img/maps.5a8caadf.png";